import React, { useState } from 'react';
import './Testimonials.css';
import { testimonialsData } from '../../data/testimonialsData';
import rightArrow from '../../assets/rightArrow.png';
import leftArrow from '../../assets/leftArrow.png';
import { motion, AnimatePresence } from 'framer-motion';


const Testimonials = () => {
    const [selected, setSelected] = useState(0);
    const tLength = testimonialsData.length;

    const transition = { type: 'spring', duration: 1 };

    const handleLeftClick = () => {
        setSelected(selected === 0 ? tLength - 1 : selected - 1);
    };

    const handleRightClick = () => {
        setSelected((selected + 1) % tLength);
    };

    return (
        <div className="Testimonials">
            <div className="left-t">
                <span>Testimonials</span>
                <span className='stroke-text'>What They</span>
                <span>say about us</span>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={selected}
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 100 }}
                        transition={transition}
                    >
                        <span>{testimonialsData[selected].review}</span>
                        <br />
                        <span style={{ color: 'var(--orange)' }}>
                            {testimonialsData[selected].name}
                        </span>{"  "} - {testimonialsData[selected].status}
                    </motion.div>
                </AnimatePresence>
            </div>

            <div className="right-t">
                <div className="image-overlay"></div>
                <div className="image-overlay-bg"></div>
                <AnimatePresence mode="wait">
                    <motion.img
                        key={selected + '-image'}
                        src={testimonialsData[selected].image}
                        alt="Testimonial"
                        initial={{ opacity: 0, x: 100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -100 }}
                        transition={transition}
                    />
                </AnimatePresence>

                <div className="arrows">
                    <img 
                        onClick={handleLeftClick}
                        src={leftArrow} 
                        alt="Left Arrow"
                    />
                    <img 
                        onClick={handleRightClick}
                        src={rightArrow} 
                        alt="Right Arrow"
                    />
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
